import {
  RailsBlock,
  RailsTile,
  RailsTileVersion,
} from '@sls-react/typings/services/rails/tile';
import useMobile from '@sls-react/hooks/useMobile';
import { useMemo } from 'react';

export default function useTileVersions(block: RailsBlock) {
  const mobile = useMobile();

  return useMemo(() => {
    return block.tiles?.map<RailsTile & Partial<RailsTileVersion>>(tile => {
      const blockLayoutVersion = tile.versions?.find(
        v => v.block_layout === block.layout,
      );

      if (blockLayoutVersion) {
        return {
          ...tile,
          ...blockLayoutVersion,
        };
      }

      const platformVersion = tile.versions?.find(
        v => v.platform === (mobile ? 'mobile' : 'web'),
      );

      return {
        ...tile,
        ...platformVersion,
      };
    });
  }, [block.layout, block.tiles, mobile]);
}
